<div class="input-group">
    <div class="input-group-text" id="btnGroupAddon">
        <i class="bi bi-person"></i>
    </div>

    <input type="text" class="form-control" placeholder="Search User" />
</div>
